import React from "react"
import { has } from "lodash"
import { v4 as uuidv4 } from "uuid"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import { Modal, Box } from "@mui/material"

class AddNewBuildConfig extends React.Component {
    constructor(props) {
        super(props);
        const platform = this.props.appConfig.platforms ? this.props.appConfig.platforms.split(',')[0] : null;
        this.pageSize = 10
        this.state = {
            error: "",
            history: [],
            value: null,
            showDropdown: false,
            isLoading: true,
            page: 1,
            loadMore: true,
            initialLoad: true,
            platform,
            showConfirmDelete: false,
            separateEventBundle: false,
        }
        this.timeOutId = null
        this.dropDownRef = React.createRef()
        this.optionRefs = []
    }
    optionRef = (ref) => {
        this.optionRefs.push(ref)
    }
    handleSubmit = (e) => {
        e.preventDefault()
        if (this.validate()) {
            fetch(`/api/data/project/${this.props.projectId}/appConfig/${this.props.appConfigId}/buildConfig`, {
                method: "post",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    version: this.state.value.name,
                    platform: this.state.platform,
                    separateEventBundle: this.state.separateEventBundle,
                })
            })
                .then(res => res.json())
                .then(data => {
                    if (has(data, "error")) { throw data }
                    this.props.getBuildConfig(0, true)
                })
                .catch(data => this.setState({ error: `Server: ${data.error}` }))
        }
    }
    validate = () => {
        if (this.state.value === null) {
            this.setState({ error: "Select a version!" })
            return false
        }
        return true
    }
    getVersionHistory = (offset) => {
        fetch(`/api/data/project/${this.props.projectId}/version/list?limit=${this.pageSize}&offset=${offset}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                var loadMore = true
                if (data.results.length < this.pageSize) {
                    loadMore = false
                }
                this.setState(prevState => {
                    return {
                        history: [...prevState.history, ...data.results.sort((a, b) => b.code - a.code)],
                        isLoading: false,
                        initialLoad: false,
                        loadMore: loadMore
                    }
                })
            })
            .catch(data => {
                this.setState({
                    error: `Server: ${data.error}`,
                    isLoading: false
                })
            })
    }
    submitDropDownValue = (value) => {
        this.setState({
            value: value,
            showDropdown: false
        })
    }
    loadMore = (e) => {
        this.setState(prevState => {
            return {
                page: prevState.page + 1,
                isLoading: true
            }
        }, () => this.getVersionHistory((this.state.page - 1) * this.pageSize))
        e.preventDefault()
        e.stopPropagation()
    }
    toggleDropDown = (e) => {
        this.setState(prevState => {
            return {
                showDropdown: !prevState.showDropdown
            }
        }, () => this.optionRefs = this.optionRefs.filter(ref => ref !== null))
    }
    hideDropDown = (e) => {
        if (this.state.showDropdown === true && !this.dropDownRef.current.contains(e.target)) {
            this.setState({
                showDropdown: false
            });
        }
    }
    onFocusHandler() {
        clearTimeout(this.timeOutId);
    }
    handleKeyDown = (e) => {
        //expand dropdown
        if (e.key === "Enter") this.setState({ showDropdown: true })
        //submit from keyboard
        if (e.target.classList.contains("option") && (e.key === "Enter" || e.key === " ")) e.target.click()
        //collapse dropdown
        if (e.key === "Escape") this.setState({ showDropdown: false })
        //up and down key to navigate the options
        var index = this.optionRefs.indexOf(e.target)
        if (index === -1) {
            if (e.key === "ArrowDown" && this.state.showDropdown === true) {
                this.optionRefs[0].focus()
            }
        }
        if (index !== -1) {
            if (e.key === "ArrowDown" && index <= this.optionRefs.length - 2) {
                this.optionRefs[index + 1].focus()
            }
            if (e.key === "ArrowUp" && index >= 1) {
                this.optionRefs[index - 1].focus()
            }
        }
    }
    componentDidMount() {
        this.getVersionHistory(0)
        window.addEventListener("click", this.hideDropDown)
    }
    componentWillUnmount() {
        window.removeEventListener("click", this.hideDropDown)
    }
    handlePlatform = e => {
        this.setState({platform: e.target.value});
    }
    handleSeparateEventBundle = e => {
        this.setState({separateEventBundle: e.target.value});
    }
    handleShowConfirmDelete = (e) => {
        e.preventDefault();
        this.setState({ showConfirmDelete: true });
    }
    handleDelete = (e) => {
        e.preventDefault();
        if (this.validate()) {
            fetch(`/api/data/project/${this.props.projectId}/version/delete?name=${this.state.value.name}`)
            .then(res => res.json())
            .then(data => {
                if (has(data, "error")) { throw data }
                this.setState({ showConfirmDelete: false });
                this.props.cancelNewConfig(e);
            })
            .catch(data => {
                this.setState({
                    error: `Server: ${data.error}`,
                    showConfirmDelete: false,
                })
            })
        }
    }
    render() {
        this.optionRefs.length = 0
        if (this.state.initialLoad === true) return <div className="loading"><FontAwesomeIcon icon={faSpinner} spin /></div>
        const { isLoading, showDropdown, value, error, history, loadMore, showConfirmDelete, separateEventBundle } = this.state;
        const { platforms } = this.props.appConfig;
        const style = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            width: 800,
            transform: 'translate(-50%, -50%)',
            bgcolor: 'background.paper',
            border: '0px solid #000',
            outline: 0,
            boxShadow: 24,
            p: 4,
        };
        return (
            <div>
                <Modal
                    open={showConfirmDelete}
                    closeAfterTransition
                    onClose={() => this.setState({ showConfirmDelete: false })}
                >
                    <Box sx={style}>
                        <div className="requestForm" style={{fontFamily: "Montserrat,proxima-nova,sans-serif"}}>
                            <div style={{fontSize: "4rem", fontFamily: "inherit", color: "#ff0000"}}>Warning:</div>
                            <div style={{fontSize: "2rem", fontFamily: "inherit", color: "#000000"}}>Delete a published version is an irrevocable action! Please make sure you understand what you are doing!</div>
                            <div className="buttonGroup" style={{textAlign: "right"}}>
                                <button className="submitBtn" onClick={this.handleDelete}>
                                    Confrim Delete
                                </button>
                                <button className="cancelBtn" onClick={() => this.setState({ showConfirmDelete: false })}>
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </Box>
                </Modal>
                <div className="buildConfigForm">
                    <div className="col-2">
                        <div className="dropdownContainer" tabIndex="0" ref={this.dropDownRef}
                            aria-expanded={showDropdown} onKeyDown={this.handleKeyDown}>
                            {history.length > 0
                                ? <div className="dropdownHeader" onClick={this.toggleDropDown}>{value === null ? "Select a version to build!" : `Version: ${value.name}`}
                                    <title>Open drop down</title>
                                </div>
                                : <div className="dropdownHeader disabled">Publish a version in DreamEditor first!</div>}
                            <div className={`dropdownContent ${showDropdown === false ? "hidden" : ""}`}>
                                <div className="normalOption" role="listbox">
                                    {history.map((version) =>
                                        <div className="option" ref={this.optionRef} key={uuidv4()} aria-label={version.name} tabIndex="0" aria-hidden="true" aria-selected="false" role="option" onClick={() => this.submitDropDownValue(version)}>
                                            {`Version: ${version.name}` + (version.editorVersion ? ` - Engine: ${version.editorVersion}` : '')}
                                        </div>)}
                                </div>
                                {isLoading
                                    ? <div className="loading option"><FontAwesomeIcon icon={faSpinner} spin /></div>
                                    : null}
                                {loadMore
                                    ? <div className="option" aria-hidden="true" aria-selected="false" role="option" onClick={this.loadMore} ref={this.optionRef} tabIndex="0">Load more... </div>
                                    : null}
                            </div>
                            <p className="error">{error}</p>
                        </div>
                    </div>
                    {
                        platforms &&
                        <div className="col">
                            <select value={this.state.platform} onChange={this.handlePlatform}>
                                {
                                    platforms.split(',').map(p => <option key={p} value={p}>{p}</option>)
                                }
                            </select>
                        </div>
                    }
                    <div className="col">
                        Seperate Event Bundle:
                        <select value={separateEventBundle} onChange={this.handleSeparateEventBundle}>
                            {
                                <>
                                    <option key={false} value={false}>FALSE</option>
                                    <option key={true} value={true}>TRUE</option>
                                </>
                            }
                        </select>
                    </div>
                    <div className="col">
                        <div className="buttonGroup">
                            <button className="submitBtn" onClick={this.handleSubmit}>
                                Submit
                            </button>
                            <button className="cancelBtn" onClick={this.props.cancelNewConfig}>
                                Cancel
                            </button>
                            {
                                value &&
                                <button className="deleteBtn" onClick={this.handleShowConfirmDelete}>
                                    Delete
                                </button>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default AddNewBuildConfig